<template>
  <div class="app-container withdraw">
    <div class="filter-container flex">
    <el-row>
      <el-button size="small" type="primary" @click="onAdd">新增</el-button>
    </el-row>

    <el-row>
      <div class="header" style="display:flex;justify-content:flex-end;align-items:center;width:100%;">
        <el-select v-model="listQuery.state" placeholder="状态" type="primary" size="small" clearable>
          <el-option label="待确认" :value="0" />
          <el-option label="生成中" :value="1" />
          <el-option label="已完成" :value="2" />
        </el-select>

        <el-input
          v-model="listQuery.batch"
          placeholder="批次号"
          :clearable="true"
          style="width: 200px;margin: 0px 10px;margin-left: 20px;"
        ></el-input>
        
        <el-date-picker
          v-model="start_date"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择开始时间"
        ></el-date-picker>
        <el-date-picker
          v-model="end_date"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择结束时间"
          style="margin-left: 20px;"
        ></el-date-picker>
        
        <el-button
          size="small"
          type="primary"
          style="margin-left: 15px;"
          @click="search"
          >搜索</el-button
        >
      </div>
     </el-row>
    </div>

    <el-dialog :title="title" v-if="showDialog" :visible.sync="showDialog" :append-to-body="true" :close-on-click-modal=false>
      <el-form ref="form" :model="form" label-width="120px">
        
        <el-form-item label="批次号">
          <el-input
            v-model="form.batch"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入批次号"
          ></el-input>
        </el-form-item>

        <el-form-item label="会员卡数量">
          <el-input
            v-model.number="form.num"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入数量"
          ></el-input>
        </el-form-item>

         <el-form-item label="会员类型" >
          <el-select v-model="form.card_type" style="width: 200px">
            <el-option label="普通会员" :value="1" />
            <el-option label="金牌代理" :value="2" />
            <el-option label="银牌代理" :value="3" />
          </el-select>
        </el-form-item>

        <el-form-item label="会员有效时长(月)" v-if="form.card_type===1">
          <el-input
            v-model.number="form.months"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入数量"
          ></el-input>
        </el-form-item>

        <el-form-item label="赠送能量">
          <el-input
            v-model.number="form.energy_num"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入数量"
          ></el-input>
        </el-form-item>

        <el-form-item label="解锁课程"  >
          <el-switch
            v-model="is_course"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>

        </el-form-item>

        <el-form-item style="text-align: right">
          <el-button size="small" @click="handleCancel" :loading="btnLoading">返回</el-button>
          <el-button
            size="small"
            @click="handleSubmit"
            type="primary"
            :loading="btnLoading"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>


   
    <el-table
      :loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="margin-top: 15px;"
    >
      <el-table-column label="批次号" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.batch }}</template>
      </el-table-column>

      <el-table-column label="首张卡号" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.start_nos }}</template>
      </el-table-column>
      <el-table-column label="结尾卡号" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.end_nos }}</template>
      </el-table-column>

      <el-table-column label="会员卡数量" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.num }}</template>
      </el-table-column>

      <el-table-column label="会员时间" align="center" min-width="110">
        <template slot-scope="scope" >
          <el-tag type="success" v-if="scope.row.card_type === 2">永久</el-tag>
          <template v-else >{{ scope.row.months }}个月</template>
          </template>
      </el-table-column>

    
      <el-table-column label="是否解锁课程" align="center" min-width="95">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.is_course == 1">解锁</el-tag>
          <el-tag type="danger" v-if="scope.row.is_course == 0">锁定</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="会员卡类型" align="center" min-width="95">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.card_type == 1">普通会员</el-tag>
          <el-tag type="warning" v-if="scope.row.card_type == 2">金牌会员</el-tag>
          <el-tag type="primary" v-if="scope.row.card_type == 3">银牌会员</el-tag>
        </template>
      </el-table-column>
      
      <el-table-column label="能量" align="center" min-width="110">
        <template slot-scope="scope">{{ scope.row.energy_num }}</template>
      </el-table-column>

      <el-table-column label="状态" align="center" min-width="95">
        <template slot-scope="scope">
          <el-tag type="primary" v-if="scope.row.state == 0">待确认</el-tag>
          <el-tag type="warning" v-if="scope.row.state == 1">生成中</el-tag>
          <el-tag type="success" v-if="scope.row.state == 2">已完成</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="创建时间" align="center" min-width="110">
        <template slot-scope="scope">{{
          scope.row.created_at
        }}</template>
      </el-table-column>
     
      <el-table-column label="操作" align="center" min-width="200">
        <template slot-scope="scope">
          <el-button v-if="scope.row.state === 0" size="mini" type="primary" @click="handleUpdate(scope.row)">编辑</el-button>

          <el-button v-if="scope.row.state === 0" type="success" size="mini"
            @click="handleForbid(scope.row.id, '确认')">确认</el-button>
    

           
        <el-dialog
            title="查看收款码"
            :visible.sync="imgDialog"
            width="30%"
            :before-close="handleCloseCode"
            >

            <el-image
            style="width: 80%; height: 80%"
            :src="url"
            >
            </el-image>
            <span slot="footer" class="dialog-footer">
            </span>
        </el-dialog>

        </template>
      </el-table-column>

    </el-table>

    <div class="pagination">
      <el-pagination
        :current-page="listQuery.page"
        :page-size="listQuery.limit"
        :page-sizes="[10, 20, 30, 50]"
        :total="total"
        background
        layout="total,sizes,prev,pager,next,jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      listLoading: false,
      total: 1,
      listQuery: {
        page: 1,
        limit: 10,
        start_date: "",
        end_date: "",
        name_phone: "",
      },
      reason : '',
      from:{
      
      },
      form:{
        months:'',
        batch:'',
        is_course: true,
        num:100
      },
      start_date: "",
      end_date: "",
      dialogVisible: false,
      is_course: true,
      list: [],
      rewardMoney: 0,
      cashoutMoney: 0,
      cashoutUnAdoptMoney: 0,
      cashoutAdoptMoney: 0,
      imgDialog : false,
      rejectVisible : false,
      url:'',
      showDialog : false,
      btnLoading : false

    };
  },
  mounted() {
    this.getList();
    // console.log(this.$store.state.user.username)
  },
  methods: {
    getList() {
      this.listLoading = true;
      this.listQuery.start_date = this.start_date
        ? this.start_date + " 00:00:00"
        : "";
      this.listQuery.end_date = this.end_date
        ? this.end_date + " 23:59:59"
        : "";
      request({
        url: "/api/backend/memberCard/indexCardTask",
        method: "get",
        params: this.listQuery
      })
        .then(result => {
          this.list = result.data.data;
          this.total = result.data.total;
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(err => {
          console.log(err);
        });
    },
    onAdd() {
      this.title = "新增类型";
      this.resetData();
      this.showDialog = true;
    },
    resetData() {
      this.form = {
        months:0,
        batch:'',
        is_course: true,
        num:'',
        card_type:'',
        energy_num:0
      };
      this.is_course = true;
    },
    handleCancel() {
      this.btnLoading = false;
      this.showDialog = false;
    },
    handleUpdate(row) {
      this.resetData();
      console.log(row);
      this.form = Object.assign({}, row); // copy obj
      this.is_course =  this.form.is_course ? true : false
      this.dialogStatus = "update";
      this.showDialog = true;
      this.title = '编辑';
 
    },
    handleSubmit() {
      this.btnLoading = true;
      this.$confirm("此操作将修改类目信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((result) => {
          if (this.is_course) {
            this.form.is_course = 1;
          }else
          {
            this.form.is_course = 0;
          }
          request({
            url: "/api/backend/memberCard/createCardTask",
            method: "post",
            data: this.form,
            timeout: 0,
          })
            .then((result) => {
              this.$notify.success("操作成功");
              this.getList();
              this.showDialog = false;
            })
            .catch((err) => {
              this.$notify.error("操作失败");
            })
            .finally(() => {
              this.btnLoading = false;
              // this.showDialog = false;
            });
        })
        .catch((err) => {
          this.$notify.info("已取消");
          this.btnLoading = false;
        });
    },
    search() {
      this.getList();
    },
    handleForbid(val, text) {
      this.$confirm("此操作将生成会员卡,是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/memberCard/steateCardTask",
            method: "post",
            data: { id: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          });
        })
        .catch(() => { });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleCode(row) {
      this.imgDialog = true;
      this.url = row.pay_code;
    },
    handleCloseCode(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            this.imgDialog = false;
            this.rejectVisible = false;
            this.url = '';
            this.from = {};
          })
          .catch(_ => {});
      },
    cancel() {
      this.dialogVisible = false;
      },
  }
};
</script>

<style>
.fenxiao {
  display: inline-block;
  padding: 20px 30px;
  margin-right: 20px;
  background-color: rgba(255, 0, 0, 0.438);
  color: #ffffff;
  margin-top: 10px;
  border-radius: 30px;
}
.flex {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
</style>